import type { RouteParamsRequest } from '@pba/react-utils';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { MedicalGroupDetailDataObject } from '#models/services';
import { routes } from '../routes';

export const getMedicalGroupDetail = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  getNodeApiAxiosInstance().get<MedicalGroupDetailDataObject, AxiosResponse<MedicalGroupDetailDataObject>>(
    routes.medicalGroups.get(id),
  );
